import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';

import ErrorList from '../components/ErrorList.vue';
import NpCheckbox from '../components/NpCheckbox.vue';
import NpFieldset from '../components/NpFieldset.vue';
import NpInput from '../components/NpInput.vue';
import NpRadio from '../components/NpRadio.vue';
import NpSelect from '../components/NpSelect.vue';
import NPNumberRange from '../components/NPNumberRange.vue';
import NpTextarea from '../components/NpTextarea.vue';

export default Vue.extend({
	components: {
		NpInput,
		NpSelect,
		ErrorList,
		NpRadio,
		NpCheckbox,
		NpFieldset,
		NpTextarea,
		NPNumberRange,
	},
	data() {
		return {
			errorMessages: [],
		} as { errorMessages: any[] };
	},
	computed: {
		...mapState([
			'ajaxUrl',
			'formErrors',
			'generalErrors',
			'isLoading',
			'paths',
		]),
		...mapGetters(['hasErrors']),
	},
});
